import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import type { SopImprovementStatus } from '@erp/shared-types';

export function useSopImprovementSettings(taskId: string) {
  return useQuery(
    orpc.agent.sopImprovements.getSettings.queryOptions({ input: { taskId } }),
  );
}

export function useSopImprovementList(input: {
  sopId?: string;
  taskId?: string;
  status?: SopImprovementStatus;
  offset?: number;
}) {
  return useQuery({
    ...orpc.agent.sopImprovements.list.queryOptions({
      input: { ...input, limit: 25 },
    }),
    refetchInterval: 15_000,
  });
}

export function useSopImprovementActions() {
  const queryClient = useQueryClient();
  const onSuccess = async () => {
    await Promise.all([
      queryClient.invalidateQueries({
        queryKey: orpc.agent.sopImprovements.key(),
      }),
      queryClient.invalidateQueries({ queryKey: orpc.agent.key() }),
    ]);
  };
  const accept = useMutation({
    mutationFn: rpcClient.agent.sopImprovements.accept,
    onSuccess,
  });
  const dismiss = useMutation({
    mutationFn: rpcClient.agent.sopImprovements.dismiss,
    onSuccess,
  });
  const regenerate = useMutation({
    mutationFn: rpcClient.agent.sopImprovements.regenerate,
    onSuccess,
  });
  return { accept, dismiss, regenerate };
}
